import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "./ui/collapsible";
import { useIsMobile } from "@/hooks/use-mobile";
import { Separator } from "./ui/separator";
export const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();

  // Don't render on mobile
  if (isMobile) {
    return null;
  }
  return <footer className="w-full bg-muted/30 border-t">
      <Collapsible open={isOpen} onOpenChange={setIsOpen} className="w-full">
        <div className="flex justify-center border-b py-2">
          <CollapsibleTrigger className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
            Mais informações
            {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </CollapsibleTrigger>
        </div>

        <CollapsibleContent>
          <div className="container py-8 grid grid-cols-5 gap-x-4 gap-y-6 text-sm">
            <div>
              <h4 className="font-medium mb-4">Sobre a</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Ink Webtoons</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Investor relations</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Tendências</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Sustentabilidade</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Blog</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium mb-4">Outros sites</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Desenvolvedores</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Comunidade</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Manifesto da INK</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Ink Shops</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Ink Ads</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium mb-4">Contato</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Comprar</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Vender</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Solução de problemas</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Segurança</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium mb-4">Redes sociais</h4>
              <ul className="space-y-2">
                <li><a href="https://x.com/InkWebtoons" className="text-muted-foreground hover:text-foreground transition-colors">X</a></li>
                <li><a href="https://www.tiktok.com/@inkwebtoons" className="text-muted-foreground hover:text-foreground transition-colors">TikTok</a></li>
                <li><a href="https://www.instagram.com/ink.webtoons" className="text-muted-foreground hover:text-foreground transition-colors">Instagram</a></li>
                <li><a href="https://br.pinterest.com/inkwebtoons/" className="text-muted-foreground hover:text-foreground transition-colors">Pinterest</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium mb-4">Minha conta</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Resumo</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Favoritos</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Vender</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium mb-4">Assinaturas</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Ink+</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Ink-Box</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Apoia-se</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Commissios+</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Info-Jobs</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-medium mb-4">Temporadas</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Dia do desenhista</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Dia do Quadrinho Nacional</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Mês do InkToons!</a></li>
                <li><a href="#" className="text-muted-foreground hover:text-foreground transition-colors">Black Friday</a></li>
              </ul>
            </div>
          </div>
        </CollapsibleContent>
      </Collapsible>

      <div className="container py-4 border-t">
        <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-muted-foreground justify-center mb-4">
          <a href="#" className="hover:text-foreground transition-colors">Trabalhe conosco</a>
          <a href="#" className="hover:text-foreground transition-colors">Termos e condições</a>
          <a href="#" className="hover:text-foreground transition-colors">Promoções</a>
          <a href="#" className="hover:text-foreground transition-colors">Como cuidamos da sua privacidade</a>
          <a href="#" className="hover:text-foreground transition-colors">Acessibilidade</a>
          <a href="#" className="hover:text-foreground transition-colors">Contato</a>
          <a href="#" className="hover:text-foreground transition-colors">Informações sobre seguros</a>
          <a href="#" className="hover:text-foreground transition-colors">Programa de Afiliados</a>
          <a href="#" className="hover:text-foreground transition-colors">Lista de presentes</a>
        </div>
        
        <div className="text-xs text-center text-muted-foreground/70">
          <p>Copyright © 2024-2025 Ink Webtoons LTDA.</p>
          <p>Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>;
};